/*
 view-creditcard-date.js
 create and handle selection list to be inserted in a <form>
 */

import core from '../../common/lib/core.js';
import constants from '../../common/lib/utils/constants.js';
import validateCreditcard from '../lib/validate-creditcard.js';
import viewTextkeys from '../../commonview/lib/view-textkeys.js';

const create = core.create; // creates basic elements not inserted into the dom
const nodetree = core.nodetree; // inserts an array of elements into a document-fragment which later may be inserted into the dom
const classnameShow = 'u-show';
const classnameHide = 'u-hide';
let monthDefaultStr;
let yearDefaultStr;
let textkeysObj = {};

function createSelectmonth(eventFilter) {
	const cName = `${eventFilter} payment__select-month-creditcard`;
	return create({
		type: 'select',
		class: cName
	});
}

function createSelectyear(eventFilter) {
	const cName = `${eventFilter} payment__select-year-creditcard`;
	return create({
		type: 'select',
		class: cName
	});
}

function yearList(n) {
	/* return: [currentYear, currentYear+1, ..., currentYear+n]  example: [2016,2017, ... ,2035] */
	const currentYear = new Date().getFullYear();
	const list = [];
	const num = (n || 20);
	let i;
	for (i = 0; i <= num; i += 1) {
		list.push(currentYear + i);
	}
	return list;
}

function createOptionsyear() {
	const nodes = [];
	const values = yearList(20);
	// TODO langage dependant insertion of year-year
	values.splice(0, 0, yearDefaultStr);
	values.forEach((value) => {
		const elm = create({
			type: 'option',
			class: 'payment__option-year-creditcard',
			value

		});
		elm.innerHTML += value;
		/* The uninserted nodes are returned as a list to be inserted with 'nodetree'-function. */
		nodes.push(elm);
	});
	return nodetree(nodes);
}

function createOptionsmonth() {
	const nodes = [];
	const months = [monthDefaultStr, '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
	months.forEach((value) => {
		const elm = create({
			type: 'option',
			class: 'payment__option-month-creditcard',
			value
		});
		elm.innerHTML += value;
		nodes.push(elm);
	});
	return nodetree(nodes);
}

function setInputValues(elm, val) {
	const txt = (val || '');
	if (elm) {
		elm.value = txt; // eslint-disable-line no-param-reassign
	}
}

function getSelectedOption(selectElement) {
	const index = Boolean((selectElement && selectElement.options) && (selectElement.selectedIndex || selectElement.selectedIndex === '0' || selectElement.selectedIndex === 0));
	const elm = (index ? selectElement.options[selectElement.selectedIndex] : null);
	return elm;
}

function show(elm) {
	core.removeClass(elm, classnameHide);
	core.addClass(elm, classnameShow);
}

function hide(elm) {
	core.removeClass(elm, classnameShow);
	core.addClass(elm, classnameHide);
}

function validateMonth(selectElm) {
	const opt = getSelectedOption(selectElm);
	const value = (opt && opt.value);
	return (validateCreditcard.month(value) ? value : null);
}

function validateYear(selectElm) {
	const opt = getSelectedOption(selectElm);
	const value = (opt && opt.value);
	return (validateCreditcard.year(value) ? value : null);
}

function validateDate(mm, yy) {
	return validateCreditcard.date(mm, yy);
}

function validateAll(selectMonthElm, selectYearElm, force) {
	let date = null;
	let feedbackDate = null;
	const month = (validateMonth(selectMonthElm) || null);
	const year = (validateYear(selectYearElm) || null);
	const feedbackYear = (year ? null : 'select the expiration year');
	const feedbackMonth = (month ? null : 'select the expiration month');
	if ((month && year) || force) {
		date = validateDate(month, year);
		feedbackDate = (date ? null : 'the expiration date must be after this month');
	}
	return {
		month,
		year,
		date,
		feedbackYear,
		feedbackMonth,
		feedbackDate
	};
}

function mainHandler(e, onEventCb, eventFilterSeparatorClassname) {
	const eventFilterSelector = `.${eventFilterSeparatorClassname}`;

	function cb(p) {
		p.e.stopPropagation();
		onEventCb();
	}
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked */
	core.handle(e, eventFilterSelector, cb, true);
}

function addListeners(elm, cbOnEvent, eventFilter, eventType) {
	function handleCreator(e) {
		mainHandler(e, cbOnEvent, eventFilter);
	}
	core.addListener(elm, eventType, handleCreator);
	return handleCreator;
}

function removeListeners(elm, handler, eventType) {
	if (elm) {
		core.removeListener(elm, eventType, handler);
	}
}

export default {
	create(p) {
		let elements = {};
		const mainEventType = 'change';
		const classNameEventFilter = 'js-eventfilter-viewcreditcarddate';
		const callbackonmainevent = (p.callbackonmainevent || function empty() {});
		textkeysObj = viewTextkeys.depositflow();
		yearDefaultStr = textkeysObj['year-shortcut-yyyy'];
		monthDefaultStr = textkeysObj['month-shortcut-mm'];
		elements.optionsmonth = (elements.optionsmonth || createOptionsmonth());
		elements.optionsyear = (elements.optionsyear || createOptionsyear());
		elements.wrapMonth = (elements.wrapMonth || createSelectmonth(classNameEventFilter));
		elements.wrapYear = (elements.wrapYear || createSelectyear(classNameEventFilter));
		elements.wrapMonth.appendChild(elements.optionsmonth);
		elements.wrapYear.appendChild(elements.optionsyear);


		function softvalidateAll() {
			return validateAll(elements.wrapMonth, elements.wrapYear, false);
		}

		function onSelectHandler() {
			const validated = softvalidateAll();
			callbackonmainevent(validated);
		}
		const monthHandler = addListeners(elements.wrapMonth, onSelectHandler, classNameEventFilter, mainEventType);
		const yearHandler = addListeners(elements.wrapYear, onSelectHandler, classNameEventFilter, mainEventType);

		return {
			wrapMonth: elements.wrapMonth,
			wrapYear: elements.wrapYear,
			show() {
				show(elements.wrapMonth);
				show(elements.wrapYear);
			},
			hide() {
				hide(elements.wrapMonth);
				hide(elements.wrapYear);
			},
			getValues() {
				const hardValidateAll = validateAll(elements.wrapMonth, elements.wrapYear, false);
				return hardValidateAll;
			},
			update(state) {
				const month = (state.view_creditcard && state.view_creditcard.month);
				const year = (state.view_creditcard && state.view_creditcard.year);
				if (month === constants.DEFAULT) {
					setInputValues(elements.wrapMonth, monthDefaultStr);
				} else if (month) {
					setInputValues(elements.wrapMonth, month);
				}
				if (year === constants.DEFAULT) {
					setInputValues(elements.wrapYear, yearDefaultStr);
				} else if (year) {
					setInputValues(elements.wrapYear, year);
				}
			},
			close() {
				removeListeners(elements.wrapYear, yearHandler);
				removeListeners(elements.wrapMonth, monthHandler);
				elements = core.deleteElementsInObjectExcept(elements, [], 'view-creditcardlast:187');
			}
		};
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/payment/lib/view-creditcard-date.js